import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App.tsx'
import i18n, { initialLanguage, isSupportedLanguage } from './i18n'
import './index.css'

// URL structure: /<lang>/... . If the first path segment is not a supported
// language, rewrite the URL (no reload) to the remembered or browser language
// before the router mounts, English as fallback.
const firstSegment = window.location.pathname.split('/')[1] ?? ''
const language = isSupportedLanguage(firstSegment) ? firstSegment : initialLanguage()

if (!isSupportedLanguage(firstSegment)) {
  const rest = window.location.pathname === '/' ? '' : window.location.pathname
  window.history.replaceState(
    null,
    '',
    `/${language}${rest}${window.location.search}${window.location.hash}`,
  )
}

void i18n.changeLanguage(language)
document.documentElement.lang = language

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
